// src/plugins/sentry.ts
import * as Sentry from '@sentry/vue';
import type { App } from 'vue';
import type { Router } from 'vue-router';

type InitSentryOptions = {
  app: App;
  router: Router;
};

export function initSentry({ app, router }: InitSentryOptions) {
  const dsn = import.meta.env.VITE_SENTRY_DSN;
  const environment = import.meta.env.VITE_APP_ENV || 'development';
  const release = import.meta.env.VITE_APP_RELEASE || 'local';
  const apiUrl = import.meta.env.VITE_API_URL;
  const tracesSampleRate = Number(import.meta.env.VITE_SENTRY_TRACES_SAMPLE_RATE || '1');

  if (!dsn) {
    console.warn('[Sentry] DSN não configurado');
    return;
  }

  Sentry.init({
    app,
    dsn,
    environment,
    release,

    integrations: [
      Sentry.browserTracingIntegration({ router }),
      Sentry.browserSessionIntegration(),
      Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
    ],

    // quais domínios devem receber cabeçalhos de tracing
    tracePropagationTargets: [
      'localhost',
      /^https:\/\/api\.flowpilotapp\.com\.br/,
      apiUrl,
    ].filter(Boolean),

    tracesSampleRate,

    beforeSend(event) {
      // evita vazar dados sensíveis em mensagens ou breadcrumbs
      if (event.request?.headers) {
        delete event.request.headers.Authorization;
        delete event.request.headers.authorization;
      }
      return event;
    },
  });
}